var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors } from '@lean-body/components/styles';
import { SwitchButton } from '@lean-body/src/view/atoms/switch_button';
export const DisplaySettingSubsection = ({ apiClient, profile, setProfile, classObject }) => {
    const onChangeLeagueParticipating = () => __awaiter(void 0, void 0, void 0, function* () {
        const updated = yield apiClient.updateLeagueParticipating(!profile.isLeagueParticipating);
        setProfile(updated);
    });
    const onChangeStreakCompletionHidden = () => __awaiter(void 0, void 0, void 0, function* () {
        const updated = yield apiClient.updateStreakCompletionHidden(!profile.isStreakCompletionHidden);
        setProfile(updated);
    });
    return (React.createElement("div", { className: css(styles.container, classObject) },
        React.createElement("div", { className: css(styles.section) },
            React.createElement("div", { className: css(styles.label) },
                "\u30EA\u30FC\u30B0\u3092\u8868\u793A",
                React.createElement("div", { className: css(styles.description) }, "\u30E9\u30F3\u30AD\u30F3\u30B0\u3067\u904B\u52D5\u7FD2\u6163\u3092\u3082\u3063\u3068\u697D\u3057\u304F")),
            React.createElement(SwitchButton, { isOn: profile.isLeagueParticipating, onClick: onChangeLeagueParticipating })),
        React.createElement("div", { className: css(styles.section) },
            React.createElement("div", { className: css(styles.label) },
                "\u9023\u7D9A\u8A18\u9332\u3092\u8868\u793A",
                React.createElement("div", { className: css(styles.description) }, "\u9023\u7D9A\u8A18\u9332\u66F4\u65B0\u304C\u305D\u306E\u5834\u3067\u308F\u304B\u308B")),
            React.createElement(SwitchButton, { isOn: !profile.isStreakCompletionHidden, onClick: onChangeStreakCompletionHidden }))));
};
const styles = StyleSheet.create({
    container: {
        margin: '0 30px',
    },
    section: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '14px 0',
        borderBottom: `1px solid ${Colors.BorderLightGray}`,
    },
    label: {
        fontSize: 14,
        fontWeight: 500,
        color: Colors.TextDark,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
    },
    description: {
        fontSize: 12,
        fontWeight: 400,
        color: Colors.Gray,
    },
});
